module.exports = __webpack_public_path__ + "static/media/squadIcons.3903fd80.svg";